/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type InputImageMask = {
  fileId?: string | undefined;
  imageUrl?: string | undefined;
};

/** @internal */
export const InputImageMask$inboundSchema: z.ZodType<
  InputImageMask,
  z.ZodTypeDef,
  unknown
> = z.object({
  file_id: z.string().optional(),
  image_url: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "file_id": "fileId",
    "image_url": "imageUrl",
  });
});
/** @internal */
export type InputImageMask$Outbound = {
  file_id?: string | undefined;
  image_url?: string | undefined;
};

/** @internal */
export const InputImageMask$outboundSchema: z.ZodType<
  InputImageMask$Outbound,
  z.ZodTypeDef,
  InputImageMask
> = z.object({
  fileId: z.string().optional(),
  imageUrl: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    fileId: "file_id",
    imageUrl: "image_url",
  });
});

export function inputImageMaskToJSON(inputImageMask: InputImageMask): string {
  return JSON.stringify(InputImageMask$outboundSchema.parse(inputImageMask));
}
export function inputImageMaskFromJSON(
  jsonString: string,
): SafeParseResult<InputImageMask, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => InputImageMask$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'InputImageMask' from JSON`,
  );
}
